import KForm from './KForm.vue'

export {
  KForm
}
